/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SiteResultView { 
    siteId?: string;
    displayName?: string;
    action?: SiteResultView.ActionEnum;
    ok?: boolean;
    message?: string;
}
export namespace SiteResultView {
    export type ActionEnum = 'GRANT' | 'REVOKE';
    export const ActionEnum = {
        GRANT: 'GRANT' as ActionEnum,
        REVOKE: 'REVOKE' as ActionEnum
    };
}